import { Flex, Text, useMediaQuery } from '@chakra-ui/react'
import React from 'react'
import IncomingCallTone from '~/assets/sounds/incoming-call-waiting-ringtone.mp3'
import { textStyleKeys } from '~/themes/textStyles'
import { phoneFormatter } from '~/utils/formatter'

import { PhoneCall, PopupQueueItem } from '@mangovoice/types'

import { PopupCallButtons } from './PopupCallButtons'

export const PopupItemCall = (props: {
  queueItem: PopupQueueItem
  autoPlay: boolean
}) => {
  const { queueItem, autoPlay } = props

  const [isLarge, isExtraLarge] = useMediaQuery([
    '(300px <= width < 380px)',
    '(min-width: 380px)',
  ])

  return (
    <>
      <Flex
        display={'flex'}
        flexDirection={'column'}
        overflowY={'auto'}
        height={'100%'}
        justifyContent={'safe center'}
      >
        <Flex
          flexDirection={'column'}
          alignItems={'center'}
          textAlign={'center'}
        >
          <Text
            textStyle={textStyleKeys.H4}
            style={{
              overflowX: 'visible',
              display: 'flex',
              fontSize: isExtraLarge ? '2rem' : isLarge ? '1.5rem' : '1rem',
              lineHeight: isExtraLarge
                ? '2.05rem'
                : isLarge
                  ? '1.55rem'
                  : '1.05rem',
            }}
          >
            {(queueItem as PhoneCall)?.name || 'Unknown Caller'}
          </Text>
          <Text
            textStyle={textStyleKeys.Body2}
            noOfLines={1}
            style={{
              overflowX: 'hidden',
              fontSize: isExtraLarge ? '2.25rem' : isLarge ? '1.5rem' : '1rem',
              lineHeight: isExtraLarge
                ? '2.75rem'
                : isLarge
                  ? '2rem'
                  : '1.25rem',
            }}
          >
            {phoneFormatter((queueItem as PhoneCall)?.number || '0000000000')}
          </Text>
        </Flex>
        <audio
          id="incoming-call-tone"
          src={IncomingCallTone}
          autoPlay={autoPlay}
          loop
        />
      </Flex>
      <PopupCallButtons queueItem={queueItem} isExtraLarge={isExtraLarge} />
    </>
  )
}
